import React from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

export const MetaTags: React.FC = () => {
  const { t, i18n } = useTranslation()

  return (
    <Helmet>
      <html lang={i18n.language} />
      <meta name="description" content={t('common.meta.description')} />
    </Helmet>
  )
}
